import * as yup from 'yup';

export abstract class DataRequest {
    [key: string]: any
    toJson = () => {
        return JSON.stringify({data: this});
    }
    abstract validationSchema(): yup.ObjectSchema<any>;
}

export default DataRequest
